import { DomainList, DomainListItemCard } from "@/components/domain";
import { useDeleteDepartment, useGetDepartments } from "@/hooks/departments";
import { T } from "@/i18n";
import { Department } from "@/models";
import { createFileRoute, Link } from "@tanstack/react-router";
import { BookUser } from "lucide-react";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/(departments)/departments")({
  component: RouteComponent,
});

function RouteComponent() {
  const query = useGetDepartments();

  return (
    <DomainList
      domain="departments"
      breadcrumbs={[
        {
          content: (
            <>
              <T tKey="departments.title" /> <BookUser width={16} height={16} />
            </>
          ),
          href: "/departments",
        },
      ]}
      tableOptions={{
        hasActions: true,
        columns: [
          {
            header: "departments.fields.name",
          },
          {
            header: "departments.fields.description",
          },
        ],
      }}
      type="table"
      data={query.data}
      isLoading={query.isLoading}
      newLink="/departments/new"
      renderItem={(department, index, isTable) => (
        <DepartmentCard department={department} key={index} isTable={isTable} />
      )}
    />
  );
}

function DepartmentCard({
  department,
  isTable,
}: {
  department: Department;
  isTable: boolean;
}) {
  const { mutateAsync } = useDeleteDepartment();
  const deleteDepartment = () => mutateAsync(department.id.toString());
  const { t } = useTranslation();
  return (
    <DomainListItemCard
      table={isTable}
      domain="departments"
      title={department.name}
      viewLink={(children, key) => (
        <Link
          key={key}
          to="/departments/$id"
          params={{ id: department.id.toString() }}
        >
          {children}
        </Link>
      )}
      editLink={(children, key) => (
        <Link
          key={key}
          to="/departments/$id/edit"
          params={{ id: department.id.toString() }}
        >
          {children}
        </Link>
      )}
      contentMap={[
        {
          label: t("departments.fields.description"),
          value: department.description || "-",
        },
      ]}
      onDelete={deleteDepartment}
    />
  );
}
